import type { ReactNode } from "react"
import { Stack, Typography } from "@mui/material"

import TruncatedText from "widgets/common/TruncatedText"

interface IconTextStackProps {
  icon: ReactNode
  text: string
  // Keeps the text on one line, cut with an ellipsis, as a table cell needs.
  noWrap?: boolean
}

const IconTextStack = ({ icon, text, noWrap = false }: IconTextStackProps) => {
  return (
    <Stack direction={"row"} gap={1} alignItems={"center"}>
      {icon}
      {noWrap ? (
        <TruncatedText variant="body1">{text}</TruncatedText>
      ) : (
        <Typography>{text}</Typography>
      )}
    </Stack>
  )
}

export default IconTextStack
